import { defineMessages } from "react-intl";
export default defineMessages({
  myAlerts: {
    "id": "alerts.myAlerts",
    "defaultMessage": "My alerts"
  },
  alertName: {
    "id": "alerts.alertName",
    "defaultMessage": "Alert name"
  },
  conditions: {
    "id": "alerts.conditions",
    "defaultMessage": "Conditions"
  },
  noteOnConditions: {
    "id": "alerts.noteOnConditions",
    "defaultMessage": "Note that the alert is triggered when all of the below conditions are verified"
  },
  noConfiguredAlert: {
    "id": "alerts.noConfiguredAlert",
    "defaultMessage": "You don't have any alerts configured yet, start adding one"
  },
  alertAuthorizationNotice: {
    "id": "alerts.alertAuthorizationNotice",
    "defaultMessage": "Alerts work only if you authorize SmartMixin to display notifications"
  },
  addCondition: {
    "id": "alerts.addCondition",
    "defaultMessage": "Add condition"
  },
  whichMeasure: {
    "id": "alerts.whichMeasure",
    "defaultMessage": "Which measure would you like to be alerted for?"
  },
  whichModule: {
    "id": "alerts.whichModule",
    "defaultMessage": "Which module would you like to be alerted for?"
  },
  createAlert: {
    "id": "alerts.createAlert",
    "defaultMessage": "Create alert"
  },
  addAlert: {
    "id": "alerts.addAlert",
    "defaultMessage": "Add alert"
  },
  inProgress: {
    "id": "alerts.inProgress",
    "defaultMessage": "In Progress"
  },
  alertWhen: {
    "id": "alerts.alertWhen",
    "defaultMessage": "I want to be alerted when:"
  },
  alertAdded: {
    "id": "alerts.alertAdded",
    "defaultMessage": "Alert successfully added"
  },
  deleteAlert: {
    "id": "alerts.deleteAlert",
    "defaultMessage": "Delete alert"
  },
  alertDeleted: {
    "id": "alerts.alertDeleted",
    "defaultMessage": "Alert successfully deleted"
  },
  editAlert: {
    "id": "alerts.editAlert",
    "defaultMessage": "Edit alert"
  },
  editCondition: {
    "id": "alerts.editCondition",
    "defaultMessage": "Edit condition"
  },
  alertEdited: {
    "id": "alerts.alertEdited",
    "defaultMessage": "Alert successfully modified"
  },
  atLeastOneCondition: {
    "id": "alerts.atLeastOneCondition",
    "defaultMessage": "You need to add at least one condition"
  },
  windSpeedLessThan: {
    "id": "alerts.windSpeedLessThan",
    "defaultMessage": "Wind speed less than"
  },
  windSpeedGreaterThan: {
    "id": "alerts.windSpeedGreaterThan",
    "defaultMessage": "Wind speed greater than"
  },
  gustSpeedLessThan: {
    "id": "alerts.gustSpeedLessThan",
    "defaultMessage": "Gust speed less than"
  },
  gustSpeedGreaterThan: {
    "id": "alerts.gustSpeedGreaterThan",
    "defaultMessage": "Gust speed greater than"
  },
  precipitationGreaterThan: {
    "id": "alerts.precipitationGreaterThan",
    "defaultMessage": "Precipitation greater than"
  },
  pressureLessThan: {
    "id": "alerts.pressureLessThan",
    "defaultMessage": "Pressure less than"
  },
  pressureGreaterThan: {
    "id": "alerts.pressureGreaterThan",
    "defaultMessage": "Pressure greater than"
  },
  temperatureLessThan: {
    "id": "alerts.temperatureLessThan",
    "defaultMessage": "Temperature less than"
  },
  temperatureGreaterThan: {
    "id": "alerts.temperatureGreaterThan",
    "defaultMessage": "Temperature greater than"
  },
  humidityLessThan: {
    "id": "alerts.humidityLessThan",
    "defaultMessage": "Humidity less than"
  },
  humidityGreaterThan: {
    "id": "alerts.humidityGreaterThan",
    "defaultMessage": "Humidity greater than"
  },
  co2LessThan: {
    "id": "alerts.co2LessThan",
    "defaultMessage": "CO2 less than"
  },
  co2GreaterThan: {
    "id": "alerts.co2GreaterThan",
    "defaultMessage": "CO2 greater than"
  },
  noiseLessThan: {
    "id": "alerts.noiseLessThan",
    "defaultMessage": "Noise less than"
  },
  noiseGreaterThan: {
    "id": "alerts.noiseGreaterThan",
    "defaultMessage": "Noise greater than"
  },
  windSpeedLessThanThreshold: {
    "id": "alerts.windSpeedLessThanThreshold",
    "defaultMessage": "Wind speed less than {value}{unit} threshold"
  },
  windSpeedGreaterThanThreshold: {
    "id": "alerts.windSpeedGreaterThanThreshold",
    "defaultMessage": "Wind speed greater than {value}{unit} threshold"
  },
  gustSpeedLessThanThreshold: {
    "id": "alerts.gustSpeedLessThanThreshold",
    "defaultMessage": "Gust speed less than {value}{unit} threshold"
  },
  gustSpeedGreaterThanThreshold: {
    "id": "alerts.gustSpeedGreaterThanThreshold",
    "defaultMessage": "Gust speed greater than {value}{unit} threshold"
  },
  precipitationGreaterThanThreshold: {
    "id": "alerts.precipitationGreaterThanThreshold",
    "defaultMessage": "Precipitation greater than {value}{unit} threshold"
  },
  pressureLessThanThreshold: {
    "id": "alerts.pressureLessThanThreshold",
    "defaultMessage": "Pressure less than {value}{unit} threshold"
  },
  pressureGreaterThanThreshold: {
    "id": "alerts.pressureGreaterThanThreshold",
    "defaultMessage": "Pressure greater than {value}{unit} threshold"
  },
  temperatureLessThanThreshold: {
    "id": "alerts.temperatureLessThanThreshold",
    "defaultMessage": "Temperature less than {value}{unit} threshold"
  },
  temperatureGreaterThanThreshold: {
    "id": "alerts.temperatureGreaterThanThreshold",
    "defaultMessage": "Temperature greater than {value}{unit} threshold"
  },
  humidityLessThanThreshold: {
    "id": "alerts.humidityLessThanThreshold",
    "defaultMessage": "Humidity less than {value}{unit} threshold"
  },
  humidityGreaterThanThreshold: {
    "id": "alerts.humidityGreaterThanThreshold",
    "defaultMessage": "Humidity greater than {value}{unit} threshold"
  },
  co2LessThanThreshold: {
    "id": "alerts.co2LessThanThreshold",
    "defaultMessage": "CO2 less than {value}{unit} threshold"
  },
  co2GreaterThanThreshold: {
    "id": "alerts.co2GreaterThanThreshold",
    "defaultMessage": "CO2 greater than {value}{unit} threshold"
  },
  noiseLessThanThreshold: {
    "id": "alerts.noiseLessThanThreshold",
    "defaultMessage": "Noise less than {value}{unit} threshold"
  },
  noiseGreaterThanThreshold: {
    "id": "alerts.noiseGreaterThanThreshold",
    "defaultMessage": "Noise greater than {value}{unit} threshold"
  },
  visiblityLessThan: {
    "id": "alerts.visiblityLessThan",
    "defaultMessage": "Visibility less than"
  },
  visiblityGreaterThan: {
    "id": "alerts.visiblityGreaterThan",
    "defaultMessage": "Visibility greater than"
  },
  uvLessThan: {
    "id": "alerts.uvLessThan",
    "defaultMessage": "UV index less than"
  },
  uvGreaterThan: {
    "id": "alerts.uvGreaterThan",
    "defaultMessage": "UV index greater than"
  },
  solarRadiationLessThan: {
    "id": "alerts.solarRadiationLessThan",
    "defaultMessage": "Solar radiation less than"
  },
  solarRadiationGreaterThan: {
    "id": "alerts.solarRadiationGreaterThan",
    "defaultMessage": "Solar radiation greater than"
  },
  aqiLessThan: {
    "id": "alerts.aqiLessThan",
    "defaultMessage": "AQI less than"
  },
  aqiGreaterThan: {
    "id": "alerts.aqiGreaterThan",
    "defaultMessage": "AQI greater than"
  },
  pm1LessThan: {
    "id": "alerts.pm1LessThan",
    "defaultMessage": "PM 1 less than"
  },
  pm1GreaterThan: {
    "id": "alerts.pm1GreaterThan",
    "defaultMessage": "PM 1 greater than"
  },
  pm10LessThan: {
    "id": "alerts.pm10LessThan",
    "defaultMessage": "PM 10 less than"
  },
  pm10GreaterThan: {
    "id": "alerts.pm10GreaterThan",
    "defaultMessage": "PM 10 greater than"
  },
  pm2p5LessThan: {
    "id": "alerts.pm2p5LessThan",
    "defaultMessage": "PM 2.5 less than"
  },
  pm2p5GreaterThan: {
    "id": "alerts.pm2p5GreaterThan",
    "defaultMessage": "PM 2.5 greater than"
  },
  visibilityLessThanThreshold: {
    "id": "alerts.visibilityLessThanThreshold",
    "defaultMessage": "Visibility less than {value}{unit} threshold"
  },
  visibilityGreaterThanThreshold: {
    "id": "alerts.visibilityGreaterThanThreshold",
    "defaultMessage": "Visibility greater than {value}{unit} threshold"
  },
  uvLessThanThreshold: {
    "id": "alerts.uvLessThanThreshold",
    "defaultMessage": "UV index less than {value}{unit} threshold"
  },
  uvGreaterThanThreshold: {
    "id": "alerts.uvGreaterThanThreshold",
    "defaultMessage": "UV index greater than {value}{unit} threshold"
  },
  solarRadiationLessThanThreshold: {
    "id": "alerts.solarRadiationLessThanThreshold",
    "defaultMessage": "Solar radiation less than {value}{unit} threshold"
  },
  solarRadiationGreaterThanThreshold: {
    "id": "alerts.solarRadiationGreaterThanThreshold",
    "defaultMessage": "Solar radiation greater than {value}{unit} threshold"
  },
  aqiLessThanThreshold: {
    "id": "alerts.aqiLessThanThreshold",
    "defaultMessage": "AQI less than {value}{unit} threshold"
  },
  aqiGreaterThanThreshold: {
    "id": "alerts.aqiGreaterThanThreshold",
    "defaultMessage": "AQI greater than {value}{unit} threshold"
  },
  pm1LessThanThreshold: {
    "id": "alerts.pm1LessThanThreshold",
    "defaultMessage": "PM 1 less than {value}{unit} threshold"
  },
  pm1GreaterThanThreshold: {
    "id": "alerts.pm1GreaterThanThreshold",
    "defaultMessage": "PM 1 greater than {value}{unit} threshold"
  },
  pm10LessThanThreshold: {
    "id": "alerts.pm10LessThanThreshold",
    "defaultMessage": "PM 10 less than {value}{unit} threshold"
  },
  pm10GreaterThanThreshold: {
    "id": "alerts.pm10GreaterThanThreshold",
    "defaultMessage": "PM 10 greater than {value}{unit} threshold"
  },
  pm2p5LessThanThreshold: {
    "id": "alerts.pm2p5LessThanThreshold",
    "defaultMessage": "PM 2.5 less than {value}{unit} threshold"
  },
  pm2p5GreaterThanThreshold: {
    "id": "alerts.pm2p5GreaterThanThreshold",
    "defaultMessage": "PM 2.5 greater than {value}{unit} threshold"
  }
});